 export enum UserRole {
    ADMIN = "ADMIN",
    BACKOFFICE = "BACKOFFICE",
    USER = "USER"
}
